import React from 'react';
import BtnSubmit from '../../Shared/Buttons/BtnSubmit';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import { Container, Row, Col } from 'reactstrap';
import { isMobile } from 'react-device-detect';
const ServiceBoxPopUp = (props) => {
  console.log(props);
  if (props.isWorkOrderSucceeded === '') {
    return (
      <div className='service-box-popup'>
        <h4 className='service-box-popup-header'> בחרת מוצר מעולה </h4>
        <div style={{ fontSize: !isMobile ? '24px' : '18px', marginBottom: isMobile ? '15px' : '12px' }} className='txt-block'>
          שנציג יצור איתך קשר?
        </div>
        <div className='btns'>
          {!isMobile && (
            <Container>
              <Row style={{ flexWrap: 'inherit', display: isMobile ? 'grid' : 'inline-flex' }}>
                <Col className='pr-0 '>
                  <BtnWhite
                    style={{ height: '50px' }}
                    className='h-50'
                    onclick={() => {
                      props.showPopUp(false);
                    }}
                    text='אין צורך'
                  />
                </Col>
                <Col>
                  <BtnSubmit
                    onclick={() => {
                      props.openPopUpAndWorkOrder(props.product, props.organizationWorkOrderTeam, props.organizationWorkOrderCode);
                      console.log(props.isWorkOrderSucceeded);
                    }}
                    text='כן, תודה'
                  />
                </Col>
              </Row>
            </Container>
          )}
          {isMobile && (
            <Container>
              <Row style={{ flexWrap: 'inherit', display: isMobile ? 'grid' : 'inline-flex' }}>
                <Col>
                  <BtnSubmit
                    onclick={() => {
                      props.openPopUpAndWorkOrder(props.product, props.organizationWorkOrderTeam, props.organizationWorkOrderCode);
                      console.log(props.isWorkOrderSucceeded);
                    }}
                    text='כן, תודה'
                  />
                </Col>
                <Col className='pr-0 '>
                  <BtnWhite
                    style={{ height: '50px' }}
                    className='h-50'
                    onclick={() => {
                      props.showPopUp(false);
                    }}
                    text='אין צורך'
                  />
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </div>
    );
  } else if (props.isWorkOrderSucceeded === false) {
    return (
      <div className='service-box-popup'>
        <h4 className='service-box-popup-header'>משהו קרה ופנייתך לא נשלחה</h4>
        <div className='txt-block' style={{ fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '15px' }}>
          באפשרותך לנסות שוב או לפנות לאיש הקשר מארגונך
        </div>
        <div className='btns single-btn'>
          <Container>
            <Row style={{}}>
              <Col className='pr-0 pl-0'>
                <BtnSubmit
                  onclick={() => {
                    props.resetIsWorkOrderSucceeded();
                    props.showPopUp(false);
                  }}
                  text='סיום'
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  } else if (props.isWorkOrderSucceeded === true) {
    return (
      <div className='service-box-popup'>
        <h4 className='service-box-popup-header'>פנייתך הועברה לצוותון</h4>
        <div className='txt-block' style={{ fontSize: isMobile ? '18px' : '22px', marginBottom: isMobile ? '10px' : '15px' }}>
          נציג יחזור אליך תוך 2 ימי עסקים
        </div>
        <div className='btns single-btn'>
          <Container>
            <Row style={{}}>
              <Col className='pr-0 pl-0'>
                <BtnSubmit
                  onclick={() => {
                    props.resetIsWorkOrderSucceeded();
                    props.showPopUp(false);
                  }}
                  text='סיום'
                />
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    );
  }
};
export default ServiceBoxPopUp;
